import React from "react";
import styles from "../../PropertySelector.module.scss";
import PropertyDescription from "./PropertyDescription";

export default function CheckboxPropertySelectorWrapper(props) {
    const { children } = props;

    return (
        <>
            <div className={styles["property-content"]}>{children}</div>
            <PropertyDescription {...props} />
        </>
    );
}
